/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InverterIGBTData } from './InverterIGBTData';
import type { InverterMOSFETData } from './InverterMOSFETData';
import type { InverterSimpleData } from './InverterSimpleData';
/**
 * Inverter model in DB.
 */
export type InverterAnalyticalInDB = {
    item_type?: InverterAnalyticalInDB.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: 'InverterAnalytical' | 'InverterLossMapID'; // TODO: InverterLossMapID is needed in inverter.component.ts. Change @Input() part!: InverterAnalyticalInDB; to something more generic
    inverter_data: (InverterSimpleData | InverterIGBTData | InverterMOSFETData);
    current_limit_rms?: (number | null);
    _id?: string;
    id?: string; // TODO: This is required
};
export namespace InverterAnalyticalInDB {
    export enum item_type {
        COMPONENT = 'component',
    }
    // TODO: This is required
    export enum component_type {
      INVERTER_ANALYTICAL = 'InverterAnalytical',
    }
}

